import React from 'react';
import { classNames } from '../helpers/functions';
import Dot from './Dot';

const BetaBadge = ({
	children,
	status = 'default',
	noBackground,
	hasDot = true,
	border = false,
	size = 'small',
	className,
	onClick,
}) => {
	const TEXT_COLOR = {
		default: 'text-gray-600',
		success: 'text-green-700',
		info: 'text-blue-700',
		caution: 'text-yellow-800',
		warning: 'text-orange-800',
		error: 'text-red-700',
	};

	const BG_COLOR = {
		default: 'bg-gray-50',
		success: 'bg-green-50',
		info: 'bg-blue-50',
		caution: 'bg-yellow-100/80',
		warning: 'bg-orange-100/80',
		error: 'bg-red-50',
	};

	const BORDER_COLOR = {
		default: 'ring-gray-500/10 ring-1',
		success: 'ring-green-600/20 ring-1',
		info: 'ring-blue-700/10 ring-1',
		caution: 'ring-yellow-600/20 ring-1',
		warning: 'ring-orange-600/10 ring-1',
		error: 'ring-red-600/10 ring-1',
	};

	const SIZES = {
		xxs: 'px-1.5 py-0.5 text-xxs',
		small: 'px-2 py-1 text-xs',
		large: 'px-3 py-2 text-xs',
	};

	return (
		<span
			className={classNames(
				'inline-flex items-center rounded-md font-medium ring-inset',
				TEXT_COLOR[status],
				!noBackground ? BG_COLOR[status] : '',
				border ? BORDER_COLOR[status] : '',
				SIZES[size],
				className,
				onClick ? 'cursor-pointer' : '',
			)}
			onClick={typeof onClick === 'function' ? (e) => onClick(e) : () => {}}
		>
			{children}
		</span>
	);
};

export default ({
	children,
	status = 'default',
	noBackground,
	hasDot = true,
	border = false,
	size = 'small',
	className,
	isBeta,
	onClick,
}) => {
	if (isBeta) {
		return (
			<BetaBadge
				status={status}
				noBackground={noBackground}
				border={border}
				size={size}
				className={className}
				onClick={onClick}
			>
				{children}
			</BetaBadge>
		);
	}
	const TEXT_COLOR = {
		default: classNames(
			'text-gray-800 border-gray-200',
			noBackground ? 'bg-transparent' : 'bg-gray-100',
		),
		success: classNames(
			'text-green-800 border-green-100',
			noBackground ? 'bg-transparent' : 'bg-green-100',
		),
		error: classNames(
			'text-red-600 border-red-100',
			noBackground ? 'bg-transparent' : 'bg-red-100',
		),
		warning: classNames(
			'text-yellow-600 border-yellow-100',
			noBackground ? 'bg-transparent' : 'bg-yellow-100',
		),
		info: classNames(
			'text-blue-400 border-blue-100',
			noBackground ? 'bg-transparent' : 'bg-blue-50',
		),
	};

	const DOT_COLOR = {
		default: 'text-gray-400',
		success: 'text-green-400',
		error: 'text-red-400',
		warning: 'text-yellow-400',
		info: 'text-blue-400',
	};

	const SIZES = {
		xxs: 'px-2 py-0.5 text-xxs',
		small: 'px-2 py-0.5 text-xs',
		large: 'px-3 py-2 text-xs',
	};

	return (
		<span
			className={classNames(
				'inline-flex items-center rounded font-medium',
				SIZES[size],
				TEXT_COLOR[status] || TEXT_COLOR.default,
				border ? 'border' : '',
				className,
				onClick ? 'cursor-pointer' : '',
			)}
			onClick={typeof onClick === 'function' ? () => onClick() : () => {}}
		>
			{hasDot ? <Dot status={status} size={size} /> : null}
			{children}
		</span>
	);
};
